export const base_url = process.env.REACT_APP_BACKEND_URI;
export const uploads_uri = process.env.REACT_APP_UPLOADS_URI;
// export const APP_SESSION_TIMEOUT = 15 * 60 * 1000; // 15 minutes
export const APP_SESSION_TIMEOUT = 15 * 60 * 1000000;
